import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef } from '@spartacus/core';
import { HamburgerMenuService, NavigationUIComponent } from '@spartacus/storefront';

@Component({
    selector: 'gen-navigation-ui',
    templateUrl: './navigation-ui.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenNavigationUiComponent extends NavigationUIComponent {
  @Input() logo: any | null;
  constructor(
    protected _router: Router,
    renderer: Renderer2,
    elemRef: ElementRef,
    hamburgerMenuService: HamburgerMenuService,
    winRef: WindowRef
  ) {
    super(_router, renderer, elemRef, hamburgerMenuService, winRef);
  }

  goHome(): void {
    this._router.navigate(['/']);
  }
}
